import React from 'react';
import { ShortBody, Captions } from 'components/Typography';
import { Info } from 'react-feather';
import styled from 'styled-components';

export const StyledInfoIcon = styled(Info)`
  && {
    color: #c2d1d9;
    height: 20px;
    width: 20px;
    margin: 0px 5px;
    min-width: 20px;
    min-height: 20px;
  }
`;
export const StyledCaptions = styled(Captions)`
  && {
    color: #838ea4;
    font-size: 13px !important;
    margin: 0;
    line-height: 15px;
  }
`;

export const StyledShortBody = styled(({ reverse, ...otherProps }) => (
  <ShortBody {...otherProps} />
))`
  && {
    font-weight: 400;
    font-size: 15px !important;
    margin: 0;
    text-align: ${(props) => (props.reverse ? 'right' : 'left')}!important;
  }
`;
